"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = (0, _immutable.Record)({
  id: null,
  installed: null,
  accessible: true,
  accountId: null,
  adNetwork: null,
  name: null,
  ownerAdAccountId: null
}, 'Pixel');

exports.default = _default;
module.exports = exports.default;